import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";

const algorithms = [
  {
    id: "dfs",
    title: "Depth First Search Algorithm",
    description:
      "Depth-first search (DFS) is an algorithm for traversing or searching tree or graph data structures. The algorithm starts at the root node (selecting some arbitrary node as the root node in the case of a graph) and explores as far as possible along each branch before backtracking.",
  },
  {
    id: "bfs",
    title: "Breadth First Search Algorithm",
    description:
      "The Breadth First Search (BFS) algorithm is used to search a graph data structure for a node that meets a set of criteria. It starts at the root of the graph and visits all nodes at the current depth level before moving on to the nodes at the next depth level.",
  },
  {
    id: "topologicalSort",
    title: "Topological Sort",
    description:
      "A Topological Sort of a directed graph is a linear ordering of its vertices such that for every directed edge 'uv' from vertex 'u' to vertex 'v', 'u' comes before 'v' in the ordering.",
  },
  {
    id: "scc",
    title: "Strongly Connected Components",
    description:
      "A Strongly Connected Component is the portion of a directed graph in which there is a path from each vertex to another vertex.",
  },
  {
    id: "kruskals",
    title: "Kruskal's Algorithm",
    description:
      "Kruskal’s algorithm finds a safe edge to add to the growing forest by finding, of all the edges that connect any two trees in the forest, an edge (u,v) of least weight.",
  },
  {
    id: "prims",
    title: "Prim's Algorithm",
    description:
      "Prim's algorithm is similar to Kruskal's but it starts to build the Minimum Spanning Tree from any vertex in the graph.",
  },
  {
    id: "bellmanFord",
    title: "Bellman-Ford Algorithm",
    description:
      "The Bellman–Ford algorithm is an algorithm that computes shortest paths from a single source vertex to all of the other vertices in a weighted digraph.",
  },
  {
    id: "dag",
    title: "DAG Shortest Path Algorithm",
    description:
      "A linear-time algorithm for computing shortest paths from a single source in a directed acyclic graph.",
  },
  {
    id: "dijkstra",
    title: "Dijkstra's Algorithm",
    description:
      "Dijkstra’s algorithm is a single-source shortest-paths algorithm on a weighted, directed graph for the case in which all edge weights are nonnegative.",
  },
  {
    id: "fordfulkerson",
    title: "Ford Fulkerson Algorithm",
    description:
      "The Ford Fulkerson algorithm works by iteratively finding an augmenting path, which is a path from the source to the sink in the residual graph, i.e., the graph obtained by subtracting the current flow from the capacity of each edge.",
  },
  {
    id: "edmonKarps",
    title: "Edmon Karp's Algorithm",
    description:
      "The Edmon Karp's algorithm is identical to the Ford–Fulkerson algorithm, except that the search order when finding the augmenting path is defined. The path found must be a shortest path that has available capacity which can be found by a breadth-first search.",
  },
];

function HomePage() {
  return (
    <div>
      <div className="fade-in-container">
        <div className="background-image" />
        <div className="center-text">
          <h2 className="fade-in-text">Graph Algorithms Visualizer</h2>
          {/*<a
            href="https://forms.gle/NsMXEF8CPaviFg8d7"
            target="_blank"
            rel="noopener noreferrer"
            className="fade-in-text"
          >
            Feedback Form
  </a>*/}
        </div>
      </div>
      {
        <div className="container mt-5">
          <div className="row">
            {algorithms.map((algorithm) => (
              <div key={algorithm.id} className="col-md-4 mb-3">
                <Link
                  to={`/algorithm/${algorithm.id}`}
                  className="text-decoration-none"
                >
                  <div className="card custom-card-bg text-white d-flex flex-column h-100">
                    <div className="card-body flex-fill">
                      <h5 className="card-title">{algorithm.title}</h5>
                      <p className="card-text">{algorithm.description}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      }
    </div>
  );
}

export default HomePage;
